/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Audio_Stream_FailedInputs */

const en_audio_description_export_audio_stream_failed = /** @type {(inputs: Audio_Description_Export_Audio_Stream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`There was an error receiving the audio stream.`)
};

const fr_audio_description_export_audio_stream_failed = /** @type {(inputs: Audio_Description_Export_Audio_Stream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur est survenue lors de la réception du flux audio.`)
};

const de_audio_description_export_audio_stream_failed = /** @type {(inputs: Audio_Description_Export_Audio_Stream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Empfang des Audiostreams ist ein Fehler aufgetreten.`)
};

const it_audio_description_export_audio_stream_failed = /** @type {(inputs: Audio_Description_Export_Audio_Stream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore durante la ricezione del flusso audio.`)
};

const ru_audio_description_export_audio_stream_failed = /** @type {(inputs: Audio_Description_Export_Audio_Stream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Произошла ошибка при приеме аудиопотока.`)
};

const es_audio_description_export_audio_stream_failed = /** @type {(inputs: Audio_Description_Export_Audio_Stream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se produjo un error al recibir la transmisión de audio.`)
};

const zh_cn2_audio_description_export_audio_stream_failed = /** @type {(inputs: Audio_Description_Export_Audio_Stream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接收音频流时出错。`)
};

const ja_audio_description_export_audio_stream_failed = /** @type {(inputs: Audio_Description_Export_Audio_Stream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーディオ ストリームの受信中にエラーが発生しました。`)
};

const hi_audio_description_export_audio_stream_failed = /** @type {(inputs: Audio_Description_Export_Audio_Stream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑडियो स्ट्रीम प्राप्त करने में त्रुटि हुई।`)
};

const pt_pt2_audio_description_export_audio_stream_failed = /** @type {(inputs: Audio_Description_Export_Audio_Stream_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro ao receber o fluxo de áudio.`)
};

/**
* | output |
* | --- |
* | "There was an error receiving the audio stream." |
*
* @param {Audio_Description_Export_Audio_Stream_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_audio_stream_failed = /** @type {((inputs?: Audio_Description_Export_Audio_Stream_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Audio_Stream_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_audio_stream_failed(inputs)
	if (locale === "de") return de_audio_description_export_audio_stream_failed(inputs)
	if (locale === "it") return it_audio_description_export_audio_stream_failed(inputs)
	if (locale === "ru") return ru_audio_description_export_audio_stream_failed(inputs)
	if (locale === "es") return es_audio_description_export_audio_stream_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_audio_stream_failed(inputs)
	if (locale === "ja") return ja_audio_description_export_audio_stream_failed(inputs)
	if (locale === "hi") return hi_audio_description_export_audio_stream_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_audio_stream_failed(inputs)
	return en_audio_description_export_audio_stream_failed(inputs)
});